import { KnownProcessType, ProcessRespondentSelectionCriterionType } from "../models/process-models";
import { EnumDescription } from ".";

export class CriterionName {
    static GetCriterionName(processType: KnownProcessType, 
        selectedCriterion: ProcessRespondentSelectionCriterionType = ProcessRespondentSelectionCriterionType.None): string {
        switch (processType){
            case KnownProcessType.PME:
                return "PME";
            case KnownProcessType.PMQ:
                return "PMQ";
            case KnownProcessType.Combined:
                return "Combined";
            case KnownProcessType._360:
                return "360 " + EnumDescription.GetDescription(ProcessRespondentSelectionCriterionType, selectedCriterion as number);
            default:
                return "Unknown";
        }
    }
}